export default __webpack_public_path__ + "static/media/CNo.60-5.f4a0cdb6.jpg";